(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5657],{

/***/ 62178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d$": function() { return /* binding */ getIndexedList; },
/* harmony export */   "gp": function() { return /* binding */ getList; }
/* harmony export */ });
/* unused harmony exports getArticlesPage, getLatest, getCmsPaths, getCmsAllPaths */
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65599);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var ARTICLES_PER_PAGE = 3;

function getArticles(_x, _x2) {
  return _getArticles.apply(this, arguments);
}

function _getArticles() {
  _getArticles = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params, content) {
    var _yield$cms$get, data;

    return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _config__WEBPACK_IMPORTED_MODULE_2__/* .cms.get */ .I.get('', {
              params: _objectSpread({
                contentType: content
              }, params)
            });

          case 3:
            _yield$cms$get = _context.sent;
            data = _yield$cms$get.data;
            return _context.abrupt("return", {
              data: data || []
            });

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              data: [],
              error: _context.t0
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _getArticles.apply(this, arguments);
}

function getList(_x3) {
  return _getList.apply(this, arguments);
}

function _getList() {
  _getList = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(contentType) {
    var page,
        categorySlug,
        skip,
        _args2 = arguments;
    return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            page = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 1;
            categorySlug = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : undefined;
            skip = page > 1 ? (Number(page) - 1) * ARTICLES_PER_PAGE : undefined;
            return _context2.abrupt("return", getArticles({
              limit: ARTICLES_PER_PAGE,
              skip: skip,
              'fields.categories.slug[eq]': categorySlug,
              withLinks: true
            }, contentType));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getList.apply(this, arguments);
}

function getIndexedList(_x4) {
  return _getIndexedList.apply(this, arguments);
}

function _getIndexedList() {
  _getIndexedList = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(contentType) {
    var page,
        categorySlug,
        descending,
        skip,
        order,
        _args3 = arguments;
    return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            page = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 1;
            categorySlug = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : undefined;
            descending = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : false;
            skip = page > 1 ? (Number(page) - 1) * ARTICLES_PER_PAGE : undefined;
            order = descending ? '-fields.index' : 'fields.index';
            return _context3.abrupt("return", getArticles({
              limit: ARTICLES_PER_PAGE,
              skip: skip,
              'fields.categories.slug[eq]': categorySlug,
              withLinks: true,
              sort: order
            }, contentType));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getIndexedList.apply(this, arguments);
}

function getArticlesPage(_x5, _x6) {
  return _getArticlesPage.apply(this, arguments);
}

function _getArticlesPage() {
  _getArticlesPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params, contentType) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            setTimeout(function () {}, 10);
            return _context4.abrupt("return", getArticles(params, contentType));

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getArticlesPage.apply(this, arguments);
}

function getLatest(_x7) {
  return _getLatest.apply(this, arguments);
}

function _getLatest() {
  _getLatest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(contentType) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", getArticles({
              limit: 4
            }, contentType));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getLatest.apply(this, arguments);
}

function getCmsPaths(_x8) {
  return _getCmsPaths.apply(this, arguments);
}

function _getCmsPaths() {
  _getCmsPaths = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(contentType) {
    var _yield$getArticlesPag, _yield$getArticlesPag2, articles;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getArticlesPage({
              limit: 500
            }, contentType);

          case 2:
            _yield$getArticlesPag = _context6.sent;
            _yield$getArticlesPag2 = _yield$getArticlesPag.data.data;
            articles = _yield$getArticlesPag2 === void 0 ? [] : _yield$getArticlesPag2;
            return _context6.abrupt("return", articles.map(function (_ref) {
              var _ref$slug = _ref.slug,
                  slug = _ref$slug === void 0 ? '' : _ref$slug;
              return {
                params: {
                  slug: slug
                }
              };
            }));

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getCmsPaths.apply(this, arguments);
}

function getCmsAllPaths(_x9) {
  return _getCmsAllPaths.apply(this, arguments);
}

function _getCmsAllPaths() {
  _getCmsAllPaths = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(contentType) {
    var _yield$getArticlesPag3, _yield$getArticlesPag4, totalCalls, _yield$getArticlesPag5, articles, allArticles, i, _yield$getArticlesPag6, _yield$getArticlesPag7, newArticles;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getArticlesPage({
              limit: 500
            }, contentType);

          case 2:
            _yield$getArticlesPag3 = _context7.sent;
            _yield$getArticlesPag4 = _yield$getArticlesPag3.data;
            totalCalls = _yield$getArticlesPag4.pagination.lastPage;
            _yield$getArticlesPag5 = _yield$getArticlesPag4.data;
            articles = _yield$getArticlesPag5 === void 0 ? [] : _yield$getArticlesPag5;
            allArticles = _toConsumableArray(articles);

            if (!(totalCalls > 1)) {
              _context7.next = 20;
              break;
            }

            i = 1;

          case 10:
            if (!(i < totalCalls)) {
              _context7.next = 20;
              break;
            }

            _context7.next = 13;
            return getArticlesPage({
              limit: 500,
              skip: 500 * i
            }, contentType);

          case 13:
            _yield$getArticlesPag6 = _context7.sent;
            _yield$getArticlesPag7 = _yield$getArticlesPag6.data.data;
            newArticles = _yield$getArticlesPag7 === void 0 ? [] : _yield$getArticlesPag7;
            allArticles = [].concat(_toConsumableArray(allArticles), _toConsumableArray(newArticles));

          case 17:
            i++;
            _context7.next = 10;
            break;

          case 20:
            return _context7.abrupt("return", allArticles.map(function (_ref2) {
              var _ref2$slug = _ref2.slug,
                  slug = _ref2$slug === void 0 ? '' : _ref2$slug;
              return {
                params: {
                  slug: slug
                }
              };
            }));

          case 21:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getCmsAllPaths.apply(this, arguments);
}

/***/ }),

/***/ 56437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LayoutDynamic; }
});

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var index_esm = __webpack_require__(53854);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var io_index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./styles/layout.module.scss
var layout_module = __webpack_require__(65447);
var layout_module_default = /*#__PURE__*/__webpack_require__.n(layout_module);
// EXTERNAL MODULE: ./src/utils/dayjs.js
var dayjs = __webpack_require__(95286);
// EXTERNAL MODULE: ./src/components/SidebarCMS/SidebarCMS.jsx + 3 modules
var SidebarCMS = __webpack_require__(21054);
// EXTERNAL MODULE: ./src/components/LayoutDynamic/LayoutDynamic.module.scss
var LayoutDynamic_module = __webpack_require__(50452);
var LayoutDynamic_module_default = /*#__PURE__*/__webpack_require__.n(LayoutDynamic_module);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/usePaginationRange.js


var DOTS = '...'; // our range generator function

function range(start, end) {
  var length = end - start + 1;
  return Array.from({
    length: length
  }, function (_, index) {
    return index + start;
  });
}

function usePaginationRange(_ref) {
  var totalPageCount = _ref.totalPageCount,
      buttonConst = _ref.buttonConst,
      siblingCount = _ref.siblingCount,
      currentPage = _ref.currentPage;
  var paginationRange = (0,react.useMemo)(function () {
    // Pages count is determined as siblingCount + buttonConst(firstPage + lastPage + currentPage) + 2*DOTS
    var totalPageNumbers = buttonConst + 2 + siblingCount;
    /*
          If the number of pages is less than the page numbers we want to show in our
          paginationComponent, we return the range [1..totalPageCount]
        */

    if (totalPageNumbers >= totalPageCount) {
      return range(1, totalPageCount);
    }
    /*
        Calculate left and right sibling index and make sure they are within range 1 and totalPageCount
    */


    var leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    var rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
    /*
          We do not want to show dots if there is only one position left
          after/before the left/right page count as that would lead to a change if our Pagination
          component size which we do not want
        */

    var shouldShowLeftDots = leftSiblingIndex > 2;
    var shouldShowRightDots = rightSiblingIndex <= totalPageCount - 2;
    var firstPageIndex = 1;
    var lastPageIndex = totalPageCount;
    /*
     No left dots to show, but rights dots to be shown
    */

    if (!shouldShowLeftDots && shouldShowRightDots) {
      var leftItemCount = 3 + 2 * siblingCount;
      var leftRange = range(1, leftItemCount);
      return [].concat((0,toConsumableArray/* default */.Z)(leftRange), [DOTS, totalPageCount]);
    }
    /*
         No right dots to show, but left dots to be shown
    */


    if (shouldShowLeftDots && !shouldShowRightDots) {
      var rightItemCount = 3 + 2 * siblingCount;
      var rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
      return [firstPageIndex, DOTS].concat((0,toConsumableArray/* default */.Z)(rightRange));
    }
    /*
         Both left and right dots to be shown
    */


    if (shouldShowLeftDots && shouldShowRightDots) {
      var middleRange = range(leftSiblingIndex, rightSiblingIndex);
      return [firstPageIndex, DOTS].concat((0,toConsumableArray/* default */.Z)(middleRange), [DOTS, lastPageIndex]);
    }
  }, [totalPageCount, siblingCount, currentPage, buttonConst]);
  return paginationRange;
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/LayoutDynamic/Pagination.jsx








function Pagination(_ref) {
  var data = _ref.data,
      path = _ref.path,
      query = _ref.query;
  var currentPage = data.currentPage,
      lastPage = data.lastPage,
      totalItems = data.total,
      itemsPerPage = data.perPage;
  var hasPrevious = currentPage > 1;
  var hasNext = currentPage !== lastPage;
  var numberOfPages = Math.ceil(totalItems / itemsPerPage);
  var prevPage = currentPage > 1 ? currentPage - 1 : 1;
  var nextPage = currentPage + 1 < lastPage ? currentPage + 1 : lastPage;
  var category = get_default()(query, 'category', '');
  var contentPerPage = 3;
  var buttonConst = 3;
  var siblingCount = 1;

  function getUrl(page) {
    var url = category ? "".concat(path, "?page=").concat(page, "&category=").concat(category) : "".concat(path, "?page=").concat(page);
    return url;
  }

  var paginationRange = usePaginationRange({
    totalPageCount: numberOfPages,
    contentPerPage: contentPerPage,
    buttonConst: buttonConst,
    siblingCount: siblingCount,
    currentPage: currentPage
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: (LayoutDynamic_module_default()).pagination,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: classnames_default()((0,defineProperty/* default */.Z)({}, (LayoutDynamic_module_default()).disabled, !hasPrevious)),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: getUrl(prevPage),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (LayoutDynamic_module_default()).paginationLink,
          children: "Previous"
        })
      })
    }), paginationRange.map(function (item, index) {
      if (item === DOTS) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          (0,jsx_runtime.jsx)("button", {
            className: "paginationItem",
            children: "\u2026"
          }, index)
        );
      }

      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        (0,jsx_runtime.jsx)("li", {
          className: classnames_default()((0,defineProperty/* default */.Z)({}, (LayoutDynamic_module_default()).active, currentPage === item)),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: getUrl(item),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (LayoutDynamic_module_default()).paginationLink,
              children: item
            })
          })
        }, index)
      );
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: classnames_default()((0,defineProperty/* default */.Z)({}, (LayoutDynamic_module_default()).disabled, !hasNext)),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: getUrl(nextPage),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (LayoutDynamic_module_default()).paginationLink,
          children: "Next"
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/LayoutDynamic/LayoutDynamic.jsx











function LayoutDynamic(_ref) {
  var data = _ref.data,
      path = _ref.path,
      categories = _ref.categories,
      categoryTitle = _ref.categoryTitle,
      query = _ref.query,
      appLinks = _ref.appLinks,
      contentName = _ref.contentName;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (layout_module_default()).section,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (layout_module_default()).container,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (layout_module_default()).row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (LayoutDynamic_module_default()).column,
          children: data.data.map(function (d) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (LayoutDynamic_module_default()).card,
              children: [Boolean(get_default()(d, 'fields.cover_image')) && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "".concat(path, "/").concat(d.slug),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                    className: (LayoutDynamic_module_default()).img,
                    src: d.fields.cover_image.path,
                    alt: "Card  cap"
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (LayoutDynamic_module_default()).body,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                  className: (LayoutDynamic_module_default()).title,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: "".concat(path, "/").concat(d.slug),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      children: d.title
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (LayoutDynamic_module_default()).meta,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (LayoutDynamic_module_default()).tags,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: (LayoutDynamic_module_default()).tagsInfo,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(io_index_esm/* IoMdCalendar */.i95, {
                          className: (LayoutDynamic_module_default()).calendarIcon,
                          alt: "\u03B5\u03B9\u03BA\u03BF\u03BD\u03AF\u03B4\u03B9\u03BF \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1\u03C2"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        children: (0,dayjs/* formatDate */.p6)(d.ct, 'DD MMMM, YYYY')
                      })]
                    }), Boolean(get_default()(d, 'fields.categories.length')) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: (LayoutDynamic_module_default()).tagsInfo,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* HiTag */.IFg, {
                          className: (LayoutDynamic_module_default()).calendarIcon,
                          alt: "\u03B5\u03B9\u03BA\u03BF\u03BD\u03AF\u03B4\u03B9\u03BF \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03B9\u03CE\u03BD \u03AC\u03C1\u03B8\u03C1\u03BF\u03C5"
                        })
                      }), d.fields.categories.map(function (category, i) {
                        return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                          href: "#",
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                            children: [category.title, " ", d.fields.categories.length === i + 1 ? '' : ', ']
                          })
                        }, category.uuid);
                      })]
                    })]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (LayoutDynamic_module_default()).text,
                  children: d.fields.summary
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "".concat(path, "/").concat(d.slug),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: (LayoutDynamic_module_default()).more,
                    children: "\u039C\u03AC\u03B8\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 >"
                  })
                })]
              })]
            }, d.uuid);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (LayoutDynamic_module_default()).aside,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SidebarCMS/* default */.Z, {
            categories: categories,
            appLinks: appLinks,
            contentName: contentName,
            categoryTitle: categoryTitle
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Pagination, {
      data: data.pagination,
      path: path,
      query: query
    })]
  });
}

/***/ }),

/***/ 36593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13282);
/* harmony import */ var _PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function PageTitle(_ref) {
  var title = _ref.title,
      heading = _ref.heading;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
    className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
        className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbs),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbPrevious),
            children: "\u0391\u03C1\u03C7\u03B9\u03BA\u03AE"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbSeparator),
          children: "/"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: heading || title
        })]
      })]
    })
  });
}

/***/ }),

/***/ 13282:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"PageTitle_section__JW_pb","content":"PageTitle_content__b6zB3","title":"PageTitle_title__MR_HW","breadcrumbs":"PageTitle_breadcrumbs__yPd2_","breadcrumbSeparator":"PageTitle_breadcrumbSeparator__bNku9","breadcrumbPrevious":"PageTitle_breadcrumbPrevious__o_DvH"};

/***/ })

}]);